// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_fl-0";
export var fulfillmentPanelBody = "_fl-1";